import { defineComponent, h, mergeProps } from "vue";

// The SVG stays in its own asset file. An external mask preserves the original
// geometry and stroke while allowing the icon to inherit the surrounding color.
export function createIcon(name: string, assetUrl: string) {
  if (/^(?:data:|blob:)/i.test(assetUrl) || !/\.svg(?:[?#]|$)/i.test(assetUrl))
    throw new Error(`Icon must reference an SVG asset file: ${name}`);
  return defineComponent({
    name,
    inheritAttrs: false,
    props: {
      size: { type: [Number, String], default: 24 },
      label: { type: String, default: undefined },
    },
    setup(props, { attrs }) {
      return () =>
        h(
          "span",
          mergeProps(attrs, {
            class: "app-icon",
            style: {
              "--icon-size": /^\d+(?:\.\d+)?$/.test(String(props.size))
                ? `${props.size}px`
                : props.size,
              "--icon-source": `url("${assetUrl}")`,
            },
            "data-icon": name,
            "data-icon-src": assetUrl,
            "aria-hidden": props.label ? undefined : "true",
            "aria-label": props.label,
            role: props.label ? "img" : undefined,
          }),
        );
    },
  });
}
